import ConfirmPhoneView from './views/ConfirmPhoneView.vue';
import SelfieInstructionsView from './views/SelfieInstructionsView.vue';
import SelfieFaceTecCamera from './views/SelfieFaceTecCamera.vue';
import ExpirationStepView from './views/ExpirationStepView.vue';
import ContractSignatureView from './views/ContractSignatureView.vue';
import CompleteStepView from './views/CompleteStepView.vue';
import CreditNotAvailable from './views/CreditNotAvailable.vue';
import ErrorView from './views/ErrorView.vue';

export default [
  {
    path: '/super-onboarding',
    name: 'minified-onboarding',
    redirect: () => ({ name: 'onboarding-minified-confirmation' }),
  },
  {
    path: '/super-onboarding/confirmacao',
    name: 'onboarding-minified-confirmation',
    component: ConfirmPhoneView,
  },
  {
    path: '/super-onboarding/instrucoes',
    name: 'onboarding-minified-instructions',
    component: SelfieInstructionsView,
  },
  {
    path: '/super-onboarding/selfie',
    name: 'onboarding-minified-facetec',
    component: SelfieFaceTecCamera,
  },
  {
    path: '/super-onboarding/error',
    name: 'onboarding-minified-selfie-error',
    component: ErrorView,
  },
  {
    path: '/super-onboarding/vencimento-das-parcelas',
    name: 'onboarding-minified-installments-expire',
    component: ExpirationStepView,
  },
  {
    path: '/super-onboarding/credito-nao-disponivel',
    name: 'onboarding-minified-credit-not-available',
    component: CreditNotAvailable,
  },
  {
    path: '/super-onboarding/assinatura-do-contrato',
    name: 'onboarding-minified-contract-agreement',
    component: ContractSignatureView,
  },
  {
    path: '/super-onboarding/completo',
    name: 'onboarding-minified-complete',
    component: CompleteStepView,
  },
];
